// extracted by mini-css-extract-plugin
export default {"container":"styles_container__444BG","container__content":"styles_container__content__5PfEt"};